import { Info, Notification } from '@highmobility/console-ui-components';
import { Link } from 'react-router-dom';

export const NotSupportedNotification = () => {
  return (
    <Notification
      className="w-full"
      renderLeftIcon={(c) => <Info className={c} />}
      renderAdditionalContent={() => (
        <p className="text-white-60">
          Not supported now; part of our future development.{' '}
          <Link
            to="https://www.high-mobility.com/car-data"
            target="_blank"
            className="font-bold hover:underline"
          >
            Learn more about car data API.
          </Link>
        </p>
      )}
    >
      Coming later
    </Notification>
  );
};
